module.exports = __webpack_public_path__ + "8695e427d51107400c593d5fa11d85f3.png";